type blueprintConfigType = {
    isShowBlueprint: boolean,
};

export const blueprintConfig: blueprintConfigType = {
    isShowBlueprint: false,
};
